import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
const FinancialSectionLink = _ref => {
  let {
    claim
  } = _ref;
  const user = useSelector(state => state.auth.user);
  return /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    size: "lg",
    as: Link,
    to: `/${user.account_type}/claims/${claim.id}/financial_details/general`,
    block: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "currency_pound"), /*#__PURE__*/React.createElement("h6", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("strong", null, "Edit")));
};
export default FinancialSectionLink;